import { Box, Grid, Typography, SxProps, Theme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useIsMobile } from "../hooks";


const AccreditationPageStyle: Record<string, SxProps<Theme>> = {
    sectionButton: (theme: Theme) => ({
        background: "#D9D9D921",
        borderRadius: "17px",
        padding: "20px",
        border: "2px solid transparent",
        cursor: "pointer",
        height: "300px",
        "&:hover": {
            background: "#D9D9D921",
            borderColor: theme.palette.secondary.main,
        },
        "&:active": {
            background: "#496B0042",
        },
    }),
    sectionButtonMobile: (theme: Theme) => ({
        background: "#D9D9D921",
        borderRadius: "17px",
        padding: "20px",
        border: "2px solid transparent",
        cursor: "pointer",
        height: "150px",
        width: "60%",
        "&:hover": {
            background: "#D9D9D921",
            borderColor: theme.palette.secondary.main,
        },
        "&:active": {
            background: "#496B0042",
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    }),

    sectionImage: {
        height: "80%",
        img: {
            height: "100%",
            width: "auto",
        },
    },
    sectionImageMobile: {
        width: "50%",
        img: {
            // height: "100%",
            width: "100%",
            height: "auto",
            textAlign: "center",
        },
    },
    sectionName: {
        fontSize: "1.5rem",
    },
    sectionNameMobile: {
        fontSize: "18px",
    },
    buttonContainerMobile: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};

type AccreditationPageCardProps = {
    navigateToUrl: string
    text: string
    image: string
}

// Card generiche delle categorie nella sezione certificazioni
export default function AccreditationPageCard({ navigateToUrl, text, image }: AccreditationPageCardProps) {
    let navigate = useNavigate();
    const { isMobile } = useIsMobile();

    return <Grid
        item
        xs={12}
        md={4}
        sx={isMobile ? AccreditationPageStyle.buttonContainerMobile : {}}
    >
        <Box
            sx={
                isMobile
                    ? AccreditationPageStyle.sectionButtonMobile
                    : AccreditationPageStyle.sectionButton
            }
            onClick={() => navigate(navigateToUrl)}
        >
            <Box sx={AccreditationPageStyle.sectionImage}>
                <img src={image} />
            </Box>
            <Typography
                sx={
                    isMobile
                        ? AccreditationPageStyle.sectionNameMobile
                        : AccreditationPageStyle.sectionName
                }
            >
                {text}
            </Typography>
        </Box>
    </Grid>
}